// pages/QuantifyingHappiness.jsx
import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";
import { projects } from "../data/projectsData";

const QuantifyingHappiness = () => (
  <>
    <title>Quantifying Happiness - Arthur Efremenko</title>
    <meta
      name="description"
      content={projects.quantifyingHappiness.description}
    />
    <ProjectTemplate
      project={projects.quantifyingHappiness}
      screenshots={projects.quantifyingHappiness.screenshots}
    />
  </>
);

export default QuantifyingHappiness;
